module.exports = __webpack_public_path__ + "static/step1-2443f52c2d134b682e36d95835af3414.png";